<template>
  <div>
    <view-order-modal :order="selected_order"></view-order-modal>
    <edit-shipstation-order-modal :order="selected_order" :on-save-callback="fetchData"></edit-shipstation-order-modal>
    <!-- <send-quote-modal :order-id="selected_order.id" :email="user.email" :payment-terms="paymentTerms"></send-quote-modal> -->
    <div class="row justify-content-between">
      <div class="col-auto d-flex align-items-center">
        <h3 class="mb-0">Orders</h3>
      </div>
      <div class="col-auto align-items-center" v-if="pagination.deal_totals">
        <div class="row text-center"><small class="fw-bold">Total Won: <span class="text-success">{{ pagination.deal_totals.won | currency }}</span></small></div>
        <div class="row text-center"><small class="fw-bold">Total Pre Season: {{ pagination.deal_totals.preseason | currency }}</small></div>
        
        <!-- <div class="row"><small>Total Lost: {{ pagination.deal_totals.lost | currency }}</small></div> -->
      </div>
      <div class="col-auto d-flex align-items-center">
        <a href="order" type="button" role="button" class="btn btn-light text-white" style="background-color:#ff7a59;" >Create Order</a>
      </div>
    </div>
    <hr>
<div class="row justify-content-between align-middle">
      <div class="col-auto">
        <div class="input-group mb-3">
          <input type="text" v-model="pagination.searchparams.search" class="form-control" style="background-color:#fff" placeholder="Search..." @keyup.enter="runSearch" :readonly="loading"/>
      
            <span v-if="!search_params_changed">
              <button v-if="!loading" type="button" class="btn btn-outline-secondary  btn-search" @click="runSearch"><i class="fa fa-search"></i></button>
            
              <button v-else type="button" class="btn btn-outline-secondary btn-search" disabled><i class="fa fa-spinner fa-spin"></i></button>
            </span>
            <span v-else>
              <button type="button" class="btn btn-primary btn-search" @click="search_params_changed = false; runSearch();"><i class="fa fa-search"></i> Apply Updated Filters</button>
            </span> &nbsp &nbsp <button class="btn btn-outline-danger btn-reset pull-right" style="border-radius: 0.375rem;" type="button" role="button" @click="resetSearch">Reset</button>
             
        </div>

      </div>
      <div class="col-auto text-center" v-if="!search_params_changed">
        <p class="mt-2 mb-0">Showing <strong>{{ pagination.from | commanumeric }}</strong>-
          <strong>{{ pagination.to | commanumeric }}</strong>
          of <strong>{{ pagination.total | commanumeric }}</strong>
        </p>
      </div>
      <div class="col-auto">
        <ul class="nav justify-content-end" v-if="!loading">
          <li class="nav-item px-1">
            <div class="input-group input-group-sm">
                <span class="input-group-text">Sales Rep</span>
                <select v-model="pagination.searchparams.user" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                  <option v-for="user in pagination.filter_options.users" :key="user.id" v-bind:value="user.id">
                    {{ user.name }}
                  </option>
                </select>
              </div>
          </li>
          <li class="nav-item px-1">
            <div class="input-group input-group-sm">
                <span class="input-group-text">Customer</span>
                <select v-model="pagination.searchparams.contact" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                  <option v-for="contact in pagination.filter_options.contacts" :key="contact.id" v-bind:value="contact.id">
                    {{ contact.company_name }}
                  </option>
                </select>
              </div>
          </li>
          <li class="nav-item px-1">
            <div class="input-group input-group-sm">
                <span class="input-group-text">Status</span>
                <select v-model="pagination.searchparams.sync_status" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                  <option v-for="status in pagination.filter_options.statuses" :key="status.sync_status" v-bind:value="status.sync_status">
                    {{ status.sync_status }}
                  </option>
                </select>
              </div>
          </li>
        </ul>
      </div>
    </div>
    <div  class="row justify-content-center">
      <div class="col-md-12">
        <div class="card" v-if="pagination.data.length > 0">      
          <table class="table table-hover align-middle" style="display:table">
            <thead class="thead-light">
              <tr>
                <th scope="col" style="white-space:nowrap;" class="text-center"></th>
                <th scope="col" style="white-space:nowrap;" >Order Number</th>
                <th scope="col" style="white-space:nowrap;" >Shipstation ID</th>
                <th scope="col" style="white-space:nowrap;" >Hubspot Deal</th>
                <!-- <th scope="col" style="white-space:nowrap;" class="text-center">Created Date</th> -->
                
                <th scope="col" style="white-space:nowrap;" class="text-center">Customer</th>
                <th scope="col" style="white-space:nowrap;" class="text-center">Sales Rep</th>
                <th scope="col" style="white-space:nowrap;" class="text-center">Total Price</th>
                <th scope="col" style="white-space:nowrap;" class="text-center">Sync Status</th>
                <th scope="col" style="white-space:nowrap;" class="text-center">Shipstation Status</th>
                
                <!-- <th scope="col" style="white-space:nowrap;" class="text-center">Sync Status</th> -->
                <!-- <th scope="col" style="white-space:nowrap;">Wholesale</th> -->
                
                <th scope="col" style="white-space:nowrap;" class="text-center">Closed Date</th>
                
              </tr> 
            </thead>
            <tbody>
              <tr v-for="order in orders" :style="order.error ? 'background-color:#ff7a59;color:#fff;' : ''">
                <td class="text-start" :style="order.shipstation_status != 'shipped' ? 'padding-right:0px' : ''">
                  <a v-if="order.sync_status.includes('draft')":href="'/order/' + order.id" type="button" role="button" class="btn btn-sm btn-light text-secondary border-secondary"><i class="fa fa-pencil"></i></a>

                  <a v-else @click="viewOrder(order)" type="button" role="button" class="btn btn-sm btn-light text-secondary border-secondary"><i class="fa fa-search"></i></a>

                  <!-- <button type="button" role="button" class="btn btn-sm btn-light text-secondary border-secondary" @click="sendQuote(order.id)"><i class="fa fa-envelope-o"></i></button> -->
                  <!-- <button v-if="order.shipstation_status != 'shipped' && order.sync_status != 'Cancelled' && order.sync_status != 'Closed' && order.sync_status != 'Cancellation Queued'" type="button" role="button"  class="btn btn-sm btn-outline-danger" style="margin-left:10px;" aria-hidden="true" @click="cancelOrder(order.id)"><span v-if="!order.shipstation_status">Set to Lost</span><span v-else>Cancel</span></button> -->




                  <div class="btn-group">
                      <a class="btn btn-sm btn-light text-secondary border-secondary"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        :id="'orderOptionDropdown' + order.id"
                        aria-haspopup="true"
                        style="border-radius:5px!important;"
                      >
                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>&nbsp Actions
                      </a>
                      <div  class="dropdown-menu shadow" :aria-labelledby="'orderOptionDropdown' + order.id" data-display="static" data-boundary="window">
                        <a v-if="order.sync_status.includes('draft')":href="'/order/' + order.id" type="button" role="button" class="btn dropdown-item btn-light shadow-none"><i class="fa fa-pencil text-secondary"></i> &nbsp Edit Draft Order </a>
                        <button v-else class="btn dropdown-item btn-light shadow-none" type="button" @click="viewOrder(order)">
                          <i class="fa fa-btn fa-search text-secondary" aria-hidden="true"></i>&nbsp View Order
                        </button>
                        <button v-if="order.shipstation_status === 'awaiting_shipment'" class="btn dropdown-item btn-light shadow-none" type="button" @click="editShipstationOrder(order)">
                          <i class="fa fa-btn fa-pencil text-secondary" aria-hidden="true"></i>&nbsp Edit Shipstation Order
                        </button>
                        <button class="btn dropdown-item shadow-none" type="button" @click="duplicateOrder(order.id)">
                          <i class="fa fa-btn fa-copy" style="color:#ff7a59;" aria-hidden="true"></i>&nbsp Duplicate (Create Copy)
                        </button>
                        <button v-if="order.shipstation_status != 'shipped' && order.sync_status != 'Cancelled' && order.sync_status != 'Closed' && order.sync_status != 'Cancellation Queued'" type="button" role="button" class="btn dropdown-item btn-outline-danger shadow-none" @click="cancelOrder(order.id)">
                          <i class="fa fa-btn fa-window-close text-danger" aria-hidden="true"></i>&nbsp
                          <span v-if="!order.shipstation_status">Set to Closed Lost</span><span v-else>Cancel Order</span>
                        </button>
                      </div>
                    </div>


                </td>
                <td class="fw-bold">{{ order.order_number }}</td>
                <td class="">{{ order.shipstation_id }}</td>
                <!-- <td class="">{{ order.hubspot_id }}</td> -->
                <td class="">
                  <a v-if="order.hubspot_id" target="_blank" role="button" type="button" class="btn btn-sm btn-light" :class="[order.hubspot_status === 'Closed won' ? 'btn-outline-success' : '',order.hubspot_status === 'Closed lost' ? 'btn-outline-danger' : '']" :href="'https://app.hubspot.com/contacts/21619105/deal/' + order.hubspot_id ">
                    <span v-if="order.hubspot_status">{{ order.hubspot_status }}</span><span v-else>See Deal</span>
                  </a>
                </td>
                <!-- <td class="text-center">{{ order.created_at | moment}}</td> -->
                
                <td class="text-center">{{ order.contact }}</td>
                <td class="text-center">{{ order.user }}</td>
                <td class="text-center">{{ order.total_cost | currency }}</td>
                <!-- <td class="text-center">{{ order.tracking_number }}</td> -->
                <td class="text-center">
                  <span v-if="order.sync_status.includes('draft')" class="badge bg-secondary">Draft</span>
                  <span v-else-if="order.sync_status === 'Synced' || order.sync_status === 'Complete'" class="badge bg-success">{{ order.sync_status }}</span>
                  <span v-else class="badge bg-danger">{{ order.sync_status }}</span>
                </td>
                <td class="text-center" v-if="!order.error">
                  <span v-if="order.shipstation_status != 'shipped'">{{ order.shipstation_status }}</span>
                  <span v-else>
                    <span v-if="order.carrier == 'fedex'">
                      <a :href="'https://www.fedex.com/fedextrack/?trknbr='+ order.tracking_number" target="_blank">{{ order.tracking_number }}</a>
                    </span>
                    <span v-else-if="order.carrier == 'stamps_com'">
                      <a :href="'https://www.stamps.com/tracking-details/?t='+ order.tracking_number" target="_blank">{{ order.tracking_number }}</a>
                    </span>
                    <span v-else-if="order.tracking_number">{{ order.carrier }} {{ order.tracking_number }}</span>
                    <span v-else>
                      shipped
                    </span>
                  </span>
                </td>
                <td v-else class="text-center" v-tooltip:bottom="order.error">
                  <strong>ERROR</strong>
                </td>
                <td class="text-center"><span v-if="order.closed_at">{{ order.closed_at | moment }}</span></td>
                <!-- <td class="text-center">{{ order.retail_price | currency }}</td> -->
                
              </tr>
            </tbody>

          </table>
          <div class="row justify-content-center">
              <div v-if="pagination.data.length > 0" class="col-md-12 pt-0 pb-3">
                <nav aria-label="Page navigation">
                  <ul class="pagination nav justify-content-center">
                    <li class="page-item" ><a class="page-link" @click="firstPage"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a></li>
                    <li class="page-item" :class="{ disabled: pagination.current_page == 1 }"><a class="page-link" @click="prevPage" >Previous</a></li>
                    <li class="page-item" :class="{ disabled: !pagination.has_more_pages }"><a class="page-link" @click="nextPage">Next</a></li>
                    <li class="page-item"><a class="page-link" @click="lastPage"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a></li>
                  </ul>
                </nav>
              </div>
            </div>

        </div>
        <div v-else class="card">
          <div class="card-body">
            <div class="row justify-content-center">
              No orders matching search criteria found
            </div>
          </div>
        </div>
              <!-- <div class="card" v-for="product in products">

                  <div class="card-body row">
                      <div class="col-md-2">
                        <img style="max-height:100px;" :src="product.image_url" crossorigin="anonymous" />
                      </div>
                      <div class="col-md-5">
                        <h2>{{ product.name }}</h2>
                        <h3>$ {{ product.sale_price }}</h3>
                      </div>
                  </div>
              </div> -->
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
.btn-search {
    border-radius: 0rem .25rem .25rem 0rem;
  }

  .btn-reset {
    border-top-left-radius: 0.375rem;
  }

</style>

<script>
// import 'qs';
const qs = require('qs');
// import qs from 'qs';

import moment from 'moment'
  export default {
   props:[],
    data() {
      return {
        pagination: {
          "current_page": 1,
          "data": [],
          "first_page_url": null,
          "from": null,
          "last_page": null,
          "last_page_url": null,
          "next_page_url": null,
          "path": null,
          "prev_page_url": null,
          "to": null,
          "total": null,
          "has_more_pages": false,
          "per_page": 10,
          "filters": {
            'contacts': [],
            'statuses': [],
            'users': [],
          },
          "searchparams": {
            "search": "",
            "sortby": "created_at",
            "order": "desc",
            "user": "",
            "contact": "",
            "sync_status": "",
          },
        },
        data_endpoint: "/api/orders/order",
        search_params_changed: false,
        orders: [],
        selected_order: [],
        loading: false,
        fetched_orders: false,
      };
    },
    created() {
      // runs when the component is created
      this.fetchData();
    },
    mounted() {
      // runs when the element is injected into the browser
    },
    computed: {

    },
    methods: {
      fetchData(){
        this.fetchOrders(this.pagination.searchparams);
      },

      fetchOrders(params, page = 1) {
        this.loading = true;
        params.page = page;
        params.per_page = this.pagination.per_page;
        axios.get(this.data_endpoint, {
                params: params,
                paramsSerializer: function(params) {
                    return qs.stringify(params)
                },

          }).then((res) => {
            this.pagination = res.data;
            this.orders = res.data.data
          }).catch((error) => {
            console.log(error.response.data);
          }).finally(() => {
            this.fetched_orders = true;
            this.loading = false;
            return true;
          });
      },
      nextPage(){
        this.fetchOrders(this.pagination.searchparams, this.pagination.current_page + 1);
      },
      prevPage(){
        this.fetchOrders(this.pagination.searchparams, this.pagination.current_page - 1);
      },
      firstPage(){
        this.fetchOrders(this.pagination.searchparams, 1);
      },
      lastPage(){
        this.fetchOrders(this.pagination.searchparams, this.pagination.last_page);
      },
      runSearch() {
        this.fetchOrders(this.pagination.searchparams);
        this.search_params_changed = false;
      },
      resetSearch() {
        this.pagination.first_page_url = null;
        this.pagination.from = null;
        this.pagination.last_page = null;
        this.pagination.last_page_url = null;
        this.pagination.next_page_url = null;
        this.pagination.path = null;
        this.pagination.prev_page_url = null;
        this.pagination.to = null;
        this.pagination.total = null;
        this.pagination.has_more_pages = false;
        this.pagination.per_page = 10;
        this.pagination.searchparams.search = '';
        this.pagination.searchparams.sortby = 'created_at';
        this.pagination.searchparams.order = 'desc';
        this.pagination.searchparams.contact = '';
        this.pagination.searchparams.sync_status = '';
        this.pagination.searchparams.user = '';
        this.runSearch();
      },
      viewOrder(order) {
        this.selected_order = order;
        setTimeout(this.showOrderModal, 250);
      },
      showOrderModal() {
        Bus.$emit('viewOrderModalShow');
      },
      editShipstationOrder(order) {
        this.selected_order = order;
        setTimeout(this.showEditShipstationOrderModal, 250);
      },
      showEditShipstationOrderModal() {
        Bus.$emit('editShipstationOrderModalShow');
      },
      cancelOrder(order_id){
            // let objIndex = this.orderEdit.items.findIndex((obj => obj.id == item_id));

          let self = this;
          Swal.fire({
            title: 'Are you sure?',
            text: "This will cancel the order and mark it as 'Closed lost.' Additionally, if this order has already been split all related orders will also be cancelled.",
            // icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, cancel this order'
          }).then((result) => {
            if (result.value) {
              axios
                .post('/api/orders/cancel/' + order_id)
                .then((res) => {
                  Swal.fire(
                    'Canceled!',
                    'The order has been queued for cancelation.',
                    'success'
                  );
                  this.fetchData();
                }).catch((error) => {
                  console.log(error);
                  // Bus.$emit('newOacAlert', {text: "Could not remove order", type: 'danger'});
                });
            }
          });
        },
      duplicateOrder(order_id){
            // let objIndex = this.orderEdit.items.findIndex((obj => obj.id == item_id));

          let self = this;
          Swal.fire({
            title: 'Are you sure?',
            text: "This will create a new, identical order to the selected order.",
            // icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, copy this order'
          }).then((result) => {
            if (result.value) {
              axios
                .post('/api/orders/duplicate/' + order_id)
                .then((res) => {
                    // console.log('/order/' + res.data.data);
                    window.location.href = '/order/' + res.data.data;
                  // Swal.fire(
                  //   'Copied!',
                  //   'The order has been copied.',
                  //   'success'
                  // );
                }).catch((error) => {
                  console.log(error);
                  // Bus.$emit('newOacAlert', {text: "Could not remove order", type: 'danger'});
                });
            }
          });
        },

    },
    filters: {
        moment: function (date) {
            // return moment(date).format('MM/DD/YYYY, h:mm a');
            return moment(date).format('MMM Do, YYYY');
        }
    }
  }

</script>
